<template>
    <div id="subscribeToPrivateGallery" aria-hidden="true"
         class="modal modal--rebrand fade modal-with-custom-content modal-with-custom-content--dark-background"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" v-if="galleryDetails">
                <div v-if="false" class="modal-header" :class="{'small-header': !hasCredits}">
                    <user-credits-component v-if="false && hasCredits"></user-credits-component>
                    <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <div class="gradient-icon-container" :class="{'gradient-icon-container--gold': hasTokens}">
                        <icon-component v-if="purchaseSuccessful" :icon="imageIcon()" width="48px" height="48px"/>
                        <icon-component v-else-if="hasTokens" :icon="fa_crown()" width="48px" height="48px"/>
                        <icon-component v-else :icon="cardIcon()" width="48px" height="48px"/>
                    </div>

                    <p v-if="purchaseSuccessful" class="galleryDescription">{{ successfulPurchaseMessage }}</p>

                    <template v-else>
                        <template v-if="hasTokens">
                            <h5 class="galleryTitle">{{ translate.product.partOfVip }}</h5>
                            <p class="galleryDescription">{{ translate.product.youAreAboutToPurchaseGalleryByTokens }}</p>
                        </template>
                        <template v-else-if="hasCredits">
                            <div class="galleryPrice">
                                <span>{{ galleryDetails.prices[0].price }}</span>
                                <span>{{ translate.product.credits }}</span>
                            </div>
                            <p class="galleryDescription">{{ purchaseDescribeText }}</p>
                        </template>

                        <button-with-loading-component :disabled="purchaseLoading"
                                                       :loading="purchaseLoading"
                                                       :text="hasTokens ? translate.product.confirmPurchaseTokens : translate.product.confirmPurchase"
                                                       :class="['btn', 'btn-rebrand-sm', 'w-100', hasTokens ? 'btn-rebrand-gold-outline' : 'btn-rebrand-primary-outline']"
                                                       @click.native.prevent="subscribeToGallery()"
                        >
                        </button-with-loading-component>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import UserCreditsComponentComponent from "@/components/users/partials/UserCreditsComponent";
import dateAndTimeMixin from "@/components/mixins/dateAndTimeMixin";
import privateGalleriesMixin from "@/components/mixins/gallery/privateGalleriesMixin";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";
import IconComponent from "@/components/global/IconComponent.vue";
import {cardIcon, imageIcon, fa_crown} from "@/core/constants/icons";

const data = () => {
    return {
        purchaseLoading: false,
        hasCredits: false,
        hasTokens: false,
        galleryDetails: null,
        purchaseSuccessful: false,
    }
}

async function initModal(details) {
    this.purchaseSuccessful = false;
    this.galleryDetails = details;

    this.hasTokens = Number(_.get(this, 'currentUser.data.gallery_tokens', 0));
    this.hasCredits = Number(this.creditsString) >= _.get(this, 'galleryDetails.prices.0.price');

    if (this.hasTokens || this.hasCredits) {
        return setTimeout(() => {
            $(() => {
                const element = $('#subscribeToPrivateGallery');
                if (element && typeof element.modal === 'function') {
                    element.modal('show')
                }
            })
        })
    }

    this.setProfileInGalleryDataToLocalStorage(this.galleryDetails);

    if (this.isPunter) {
        window.location.href = this.regionRelativeUrl(NuxtRoutes.CHECKOUT.BUY_CREDITS);
    } else {
        window.location.href = this.regionRelativeUrl('/users/products/buy-credits/');
    }
}

async function subscribeToGallery() {
    this.purchaseLoading = true;

    const [err, response] = await to(
        api.gallery.purchase(this.galleryDetails.id, _.get(this, 'galleryDetails.prices.0.days')),
    );

    this.purchaseLoading = false;

    if (err || !_.get(response, 'data.success')) {
        return toastr.error(this.translate.home.errorCommon);
    }

    // for buying from fancybox gallery view
    let galleryPrice = _.get(this, 'galleryDetails.prices.0.price', 0);
    this.updateCurrentUser({credits: _.get(this.currentUser, 'credits', galleryPrice) - galleryPrice});
    this.purchaseSuccessful = true;
    if (window.location.href.indexOf('#gallery') !== -1) {
        window.history.back();
    } else {
        this.$emit('galleryPurchased');
    }
}

export default {
    data,
    methods: {
        imageIcon,
        cardIcon,
        fa_crown,
        subscribeToGallery,
        initModal,
        regionRelativeUrl,
    },
    mixins: [userMixin, dateAndTimeMixin, privateGalleriesMixin],
    computed: {
        ...mapState(['translate']),
        purchaseDescribeText() {
            return this.translate.product.youAreAboutToPurchaseGallery[0] + _.get(this, 'galleryDetails.prices.0.days')
                + this.translate.product.youAreAboutToPurchaseGallery[1] + _.get(this, 'galleryDetails.username')
                + this.translate.product.youAreAboutToPurchaseGallery[2] + _.get(this, 'galleryDetails.photoQuantity')
                + this.translate.product.youAreAboutToPurchaseGallery[3]
        },
        successfulPurchaseMessage() {
            return _.get(this, 'translate.product.galleryPurchased', '').replace(':username', _.get(this, 'galleryDetails.username'));
        },
    },
    components: {
        IconComponent,
        'user-credits-component': UserCreditsComponentComponent,
    },
    beforeDestroy() {
        window.clearModalFade();
    },
};
</script>
